import React from "react";
import { Routes, Route } from "react-router-dom";
import AppLayout from "../modules/shared/component/AppLayout";

// Page imports
import Home from "../pages/Beranda";
// Tentang
import VisiMisi from "../pages/Tentang/VisiMisi";
import Profil from "../pages/Tentang/Profil";
import StrukturOrganisasi from "../pages/Tentang/StrukturOrganisasi";
import Renmin from "../pages/Tentang/Renmin";
import Protokol from "../pages/Tentang/Protokol";
import AtpolSTP from "../pages/Tentang/AtpolSTP";
import ProfilKepolisianInternasional from "../pages/Tentang/ProfilKepolisianInternasional";
import OrganisasiInternasional from "../pages/Tentang/OrganisasiInternasional";
// Tentang / UU & Hukum
import UUHukum from "../pages/Tentang/UU/UUHukum";
import UuDetail from "../pages/Tentang/UU/UUDetail";
// NCB Interpol
import ProfilNCB from "../pages/NCBInterpol/ProfilNCB";
import BTNCLO from "../pages/NCBInterpol/BTNCLO";
import TimKoordinasi from "../pages/NCBInterpol/TimKoordinasi";
import JobVacancy from "../pages/NCBInterpol/JobVacancy";
import OperasiInterpol from "../pages/NCBInterpol/OperasiInterpol";
// Misi Internasional
import ProfilMisiInt from "../pages/MisiInternasional/ProfilMisiInternasional";
import FPU from "../pages/MisiInternasional/FPU";
import IPO from "../pages/MisiInternasional/IPO";
import MisiKemanusiaan from "../pages/MisiInternasional/MisiKemanusiaan";
import UNCapacityBuilding from "../pages/MisiInternasional/UNCapacityBuilding";
// Kerja Sama internasional
import ProfilKerjaSamaInternasional from "../pages/KerjaSamaInternasional/ProfilKerjaSamaInternasional";
import MLA from "../pages/KerjaSamaInternasional/MLA";
import MOU from "../pages/KerjaSamaInternasional/MOU";
import PerjanjianInternasional from "../pages/KerjaSamaInternasional/PerjanjianInternasional";
import KonferensiInternasional from "../pages/KerjaSamaInternasional/KonferensiInternasional";
// Berita
import Berita from "../pages/Berita/Berita";
import NewsDetail from "../pages/Berita/NewsDetail";
//Kontak
import Kontak from "../pages/Kontak";

// If you have a Theme enum, import and use it here for type safety
// import { Theme } from "../modules/shared/definitions/enum";

export type MainAppWrapperProps = {
  theme: string; // Change to Theme if you have the enum imported
  toggleTheme: () => void;
};

const MainAppWrapper: React.FC<MainAppWrapperProps> = ({
  theme,
  toggleTheme,
}) => (
  <Routes>
    <Route element={<AppLayout theme={theme} toggleTheme={toggleTheme} />}>
      {/* Beranda */}
      <Route path="/" element={<Home />} />

      {/* Tentang */}
      <Route path="/tentang/visi-misi" element={<VisiMisi />} />
      <Route path="/tentang/profil" element={<Profil />} />
      <Route
        path="/tentang/struktur-organisasi"
        element={<StrukturOrganisasi />}
      />
      <Route path="/tentang/renmin" element={<Renmin />} />
      <Route path="/tentang/protokol" element={<Protokol />} />
      <Route path="/tentang/atpol-stp" element={<AtpolSTP />} />
      <Route
        path="/tentang/profil-kepolisian-internasional/*"
        element={<ProfilKepolisianInternasional />}
      />
      <Route
        path="/tentang/organisasi-internasional/*"
        element={<OrganisasiInternasional />}
      />

      {/* Tentang / UU & Hukum */}
      <Route path="/tentang/uu-hukum" element={<UUHukum />} />
      <Route path="/tentang/uudetail/:id" element={<UuDetail />} />

      {/* NCB-Interpol */}
      <Route path="/profil-ncb" element={<ProfilNCB />} />
      <Route path="/operasi-interpol" element={<OperasiInterpol />} />
      <Route path="/btnclo" element={<BTNCLO />} />
      <Route path="/tim-koordinasi" element={<TimKoordinasi />} />
      <Route path="/job-vacancy" element={<JobVacancy />} />

      {/* Misi Internasional */}
      <Route path="/misi-internasional/profil" element={<ProfilMisiInt />} />
      <Route path="/misi-internasional/fpu" element={<FPU />} />
      <Route path="/misi-internasional/ipo" element={<IPO />} />
      <Route
        path="/misi-internasional/misi-kemanusiaan"
        element={<MisiKemanusiaan />}
      />
      <Route
        path="/misi-internasional/un-capacity-building"
        element={<UNCapacityBuilding />}
      />

      {/* Kerja Sama Internasional */}
      <Route
        path="/kerja-sama-internasional/profil"
        element={<ProfilKerjaSamaInternasional />}
      />
      <Route path="/kerja-sama-internasional/mla" element={<MLA />} />
      <Route path="/kerja-sama-internasional/mou" element={<MOU />} />
      <Route
        path="/kerja-sama-internasional/perjanjian-internasional"
        element={<PerjanjianInternasional />}
      />
      <Route
        path="/kerja-sama-internasional/konferensi-internasional"
        element={<KonferensiInternasional />}
      />

      {/* Berita */}
      <Route path="/berita" element={<Berita />} />
      <Route path="/newsdetail/:id" element={<NewsDetail />} />
      <Route path="/berita/:search" element={<Berita />} />

      {/* Kontak */}
      <Route path="/kontak" element={<Kontak />} />
    </Route>
  </Routes>
);

export default MainAppWrapper;
